import React, { useState, useContext, useEffect } from "react";
import { TokenContext } from "./TokenContext";
import iconSprite from "bootstrap-italia/dist/svg/sprite.svg";
import ModalComponent from "./ModalComponent";
import Repo from "../Utility/Repo";

function AllegatiUtenteComponent({ fiscalcode, userId }) {
  const apiToken = useContext(TokenContext);

  const [showModalAdd, setshowModalAdd] = useState(false);

  const [showModalModify, setshowModalModify] = useState(false);

  const [error, setError] = useState("");
  const initialFormData = {
    storageFileId: "",
    nomeFile: "",
    descrizione: "",
  };
  const [formData, setFormData] = useState(initialFormData);
  const [formDataList, setFormDataList] = useState([]);

  const [file, setFile] = useState();
  const [showFileToggle, toggleModalShowFile] = useState(false);

  const loadData = () => {
    if (fiscalcode != null) {
      Repo.getAllegatiUtente(apiToken, fiscalcode)
        .then((response) => {
          setFormDataList(response.data);
          // setLoading(true);
        })
        .catch((error) => {
          // setLoading(true);
          Repo.handleApiError(error, setError);
        });
    }
  };

  useEffect(() => {
    // Definisci la funzione per la richiesta GET
    loadData();

    // Cleanup della funzione se necessario (ad esempio, per cancellare sottoscrizioni o timeout)
    return () => {
      // Operazioni di cleanup, se necessario
    };
  }, []); // L'array vuoto [] indica che useEffect deve essere eseguito solo al montaggio del componente

  const resetFormFields = () => {
    setFormData(initialFormData);
    setError("");
  };

  const toggleModalAdd = () => {
    setshowModalAdd((prevShowModalAdd) => !prevShowModalAdd);
    resetFormFields();
  };

  const handleCloseModalAdd = () => {
    setshowModalAdd(false);
    resetFormFields();
  };

  const toggleModalModify = () => {
    setshowModalModify(!showModalModify);
  };

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData((prevData) => ({
      ...prevData,
      [name]: value,
    }));
  };

  const showAdd = () => {
    setshowModalAdd(true);
  };

  const handleFileChange = (e) => {
    const selectedFile = e.target.files[0];
    setFile(selectedFile);
  };

  const handleDelete = (recordId, titolo) => {
    const confirmDelete = window.confirm(
      `Sei sicuro di voler eliminare ${titolo}?`
    );

    if (confirmDelete) {
      // Chiamata API per eliminare il record
      Repo.postDeleteAllegato(apiToken, recordId)
        .then((response) => {
          if (response.status === 204) {
            // Aggiorna lo stato o effettua altre azioni dopo l'eliminazione
            // Ad esempio, puoi ricaricare i dati o aggiornare il componente.
            loadData();
          }
        })
        .catch((error) => {
          Repo.handleApiError(error, setError);
        });
    }
  };

  const handleSave = () => {
    Repo.postInsertAllegato(
      apiToken,
      "User",
      userId,
      formData.descrizione,
      file
    )
      .then((response) => {
        if (response.status === 200) {
          setshowModalAdd(false);
          window.location.reload();
        }
      })
      .catch((error) => {
        Repo.handleApiError(error, setError);
      });

    resetFormFields();
  };

  const downloadFile = (id) => {
    Repo.getFileAllegato(apiToken, id)
      .then((response) => {
        if (response.status === 200 && response.data) {
          // Converti i dati Base64 in un array di byte
          const byteCharacters = atob(response.data);
          const byteNumbers = Array.from(byteCharacters).map((char) =>
            char.charCodeAt(0)
          );
          const byteArray = new Uint8Array(byteNumbers);

          // Crea un Blob con i dati del PDF
          const blob = new Blob([byteArray], { type: "application/pdf" });

          // Crea un URL temporaneo per il Blob
          const blobUrl = URL.createObjectURL(blob);

          // Imposta il Blob URL come sorgente per il file
          setFile({
            data: blobUrl,
            type: "application/pdf",
          });

          // Mostra il modal per il file
          toggleModalShowFile(!showFileToggle);

          // Revoca l'URL dopo un breve periodo per liberare memoria
          setTimeout(() => {
            URL.revokeObjectURL(blobUrl);
          }, 1000); // Revoca l'URL dopo 1 secondo (assicurati che il file sia stato caricato)
        }
      })
      .catch((error) => {
        Repo.handleApiError(error, setError);
      });
  };

  const bodyFile = () => {
    return (
      <div>
        {file?.data ? (
          <object
            width="100%"
            height="900"
            data={file.data} // Usa il Blob URL
            type={file.type}
          >
            <p>
              Il tuo browser non supporta la visualizzazione dei PDF. Scarica il
              file{" "}
              <a href={file.data} download="document.pdf">
                qui
              </a>
              .
            </p>
          </object>
        ) : (
          <p>Nessun file caricato.</p>
        )}
      </div>
    );
  };

  const bodyAdd = () => {
    return (
      <>
        <div className="row mb-lg-3">Inserisci un nuovo allegato</div>

        <div className="row">
          <div className="col-lg-12">
            <div>
              <label htmlFor="descrizione">Descrizione:</label>
              <textarea
                id="descrizione"
                name="descrizione"
                value={formData.descrizione}
                onChange={handleChange}
                rows={4} // Imposta il numero di righe desiderato
              />
            </div>

            <div>
              <label htmlFor="fileInput" className="mr-1">
                Seleziona un file (pdf, jpeg o jpg):
              </label>
              <input
                type="file"
                id="fileInput"
                name="fileInput"
                onChange={(e) => handleFileChange(e)}
                accept=".pdf"
              />
            </div>

            <div className="d-flex justify-content-end">
              {!error && (
                <button
                  className="btn btn-primary btn-salva"
                  type="button"
                  onClick={() => handleSave()}
                >
                  Salva
                </button>
              )}
            </div>
            {error && (
              <div className="alert alert-danger mt-2" role="alert">
                <b>Attenzione:</b> {error}.
              </div>
            )}
          </div>
        </div>
      </>
    );
  };

  return (
    <div className="row no_print">
      <div className="col-lg-12 mt-3">
        <div className="card-wrapper card-space">
          <div className="card card-bg no-after card-big roundedCustom">
            <div className="etichetta">
              <svg className="icon icon-primary">
                <use href={`${iconSprite}#it-plus`}></use>
              </svg>
              <span>
                <a
                  className="text-decoration-none"
                  href="#"
                  onClick={(e) => {
                    e.preventDefault();
                    showAdd();
                  }}
                >
                  Aggiungi
                </a>
              </span>
            </div>

            <div className="card-body">
              <h4>Allegati</h4>

              <div className="container">
                <div className="row row-cols-3">
                  {formDataList && formDataList.length > 0 ? (
                    formDataList.map((allegato, index) => (
                      <div className="col" key={index}>
                        <div className="d-flex justify-content-end btn-delete-file">
                          <button
                            className="btn"
                            data-toggle="tooltip"
                            data-placement="top"
                            title="Cancella"
                            onClick={() =>
                              handleDelete(
                                allegato.storageFileId,
                                allegato.nomeFile.includes(";")
                                  ? allegato.nomeFile.split(";")[0]
                                  : allegato.nomeFile
                              )
                            }
                          >
                            <svg className="icon icon-danger icon-s">
                              <use href={`${iconSprite}#it-close`} />
                            </svg>
                          </button>
                        </div>
                        <div className="categoryicon-top">
                          <svg className="icon">
                            <use href={`${iconSprite}#it-clip`}></use>
                          </svg>

                          <span className="text ms-1">
                            <a
                              href="#"
                              className="text-decoration-none font-weight-bold"
                              onClick={(e) => {
                                e.preventDefault();
                                downloadFile(allegato.storageFileId);
                              }}
                            >
                              {allegato.nomeFile.includes(";")
                                ? allegato.nomeFile.split(";")[0]
                                : allegato.nomeFile}
                            </a>

                            <br />
                          </span>
                        </div>

                        <p className="card-text font-serif ms-1">
                          {allegato.nomeFile.includes(";")
                            ? allegato.nomeFile.split(";")[1]
                            : allegato.nomeFile}
                        </p>
                      </div>
                    ))
                  ) : (
                    <>Non sono stati caricati allegati.</>
                  )}
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      <hr />

      <ModalComponent
        toggleModal={toggleModalAdd}
        id="addFileId"
        isOpen={showModalAdd}
        header="Aggiungi"
        body={bodyAdd()}
        buttonDeny="Chiudi"
        onClose={handleCloseModalAdd}
      />

      <ModalComponent
        toggleModal={() => toggleModalShowFile(!showFileToggle)}
        isOpen={showFileToggle}
        header={"File"}
        body={bodyFile()}
        buttonDeny="Chiudi"
      ></ModalComponent>
    </div>
  );
}

export default AllegatiUtenteComponent;
